export default String.raw`
{% assign whatPrice = translations.Brutto | Downcase -%}

{% if customer.Cart.SubtotalPrices -%}
	{% assign whatPrice = translations.Netto | Downcase -%}
{% endif -%}

{% assign view = 'quick-shopping' -%}

{% if settings.selectedViewName -%}
{% assign view = settings.selectedViewName -%}
{% endif -%}

{% if page.Cookies.selectedViewName -%}
{% assign view = page.Cookies.selectedViewName -%}
{% endif -%}

<div class="products-list {% if view == 'grid' -%} with-grid-view with-grid-view-js {% endif -%}" data-base="http:{{ page.BaseHref }}" data-group-id="{{ page.GroupId }}" data-group-name="{{ page.CurrentSiteNode.Name }}" data-url="{{ page.Url }}">
	{% if page.PageId == config.DefinedPages.ProductList.Id and products.TotalItems == 0 -%}
		{% include 'partials/products/products-list-item.html' for recommended.Products -%}
	{% elseif page.PageId == config.DefinedPages.ProductList.Id -%}
    	{% include 'partials/products/products-list-item.html' for products.Products -%}
		{% include 'partials/common/image-rotate-popup.html' -%}
	{% endif -%}
</div>

{% if page.PageId == config.DefinedPages.ProductList.Id -%}
	{% include 'partials/common/pagination.html' -%}
{% endif -%}
`